import { css } from '@emotion/react';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { type Theme } from '~/_shared/themes/theme.model';
import { type TopUnderbarItem } from './topUnderbarItem.types';

const closeButtonStyle = ({ color, itemPadding }: {
  color?: string;
  itemPadding?: number | string;
}) => (theme: Theme) => css({
  color: color ?? theme.alertColors.warningPrimary,
  fontSize: 16,
  paddingRight: itemPadding ? 0 : 5,
  paddingTop: itemPadding ? 0 : 5,

  '&:hover': {
    color: theme.textColors.dangerOnHover,
  },
});

const itemStyle = (theme: Theme) => css({
  position: 'relative',
  background: theme.backgroundColors.primary,
});

const paneStyle = ({ color, backgroundColor, borderColor, padding = 6 }: {
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  padding?: number | string;
}) => (theme: Theme) => css({
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'center',
  backgroundColor,
  borderBottom: `1px solid ${borderColor ?? color ?? theme.borderColors.primary}`,
  boxSizing: 'border-box',
  color,
  padding,
  gap: 10,
  width: '100%',
});

const contentStyle = ({ color }: { color?: string}) => (theme: Theme) => css({
  display: 'flex',
  alignItems: 'center',
  color: color || theme.textColors.primary,
  width: '100%',
});

const iconStyle = ({ color, iconColor }: { color?: string; iconColor?: string }) => css({
  color: iconColor ?? color,
  paddingLeft: 10,
  paddingRight: 20,
  fontSize: 26,
});

type TopUnderbarItemComponentProps = {
  item: TopUnderbarItem;
  isMobileVersion?: boolean;
};

export const TopUnderbarItemComponent: FC<TopUnderbarItemComponentProps> = ({ item, isMobileVersion }) => {
  return (
    <div
      key={item.key}
      css={itemStyle}
    >
      <div
        css={paneStyle({
          ...item.colors,
          padding: item.padding,
        })}
      >
        <div
          css={contentStyle({
            ...item.colors,
          })}
        >
          {!isMobileVersion && item.icon && (
            <FontAwesomeIcon
              css={iconStyle({ ...item.colors })}
              icon={item.icon}
            />
          )}

          {item.children}
        </div>
        {item.onClose && (
          <FontAwesomeIcon
            css={closeButtonStyle({ color: item.colors?.color, itemPadding: item.padding })}
            icon={faXmark}
            onClick={item.onClose}
          />
        )}
      </div>
    </div>
  );
};
